module.exports = __webpack_public_path__ + "static/media/react.49f5eab3.svg";